import { Flex, Heading } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { FAQ } from '@/widgets/FAQ';
import { DefaultContainer } from '@/shared/ui';
import { JsonLdDecorator, MetaDecorator } from '@/shared/utils';
import { getBenefits } from '../lib/benefits';
import { getQuestions } from '../lib/questions';
import BenefitCard from './BenefitCard';
import PricingWidget, { IPricingWidgetProps } from './PricingWidget';
import StrongSides from './StrongSides';

const PricingPage: FC<IPricingWidgetProps> = ({ tariffs }) => {
  const { t } = useTranslation();
  const benefits = getBenefits(t);
  const questions = getQuestions(t);
  const benefitsHeading = t('pricingPage.benefitsHeading');

  const listItemsJsonLd = [
    {
      heading: benefitsHeading,
      list: benefits,
    },
  ];

  return (
    <>
      <MetaDecorator
        description='meta.pricing.description'
        title='meta.pricing.title'
      />
      <JsonLdDecorator
        faqList={questions}
        listItems={listItemsJsonLd}
        tariffs={tariffs}
      />

      <DefaultContainer alignItems='center'>
        <Heading
          as='h1'
          textAlign='center'
          w={{ base: 'full', md: '70%' }}
        >
          {t('pricingPage.heading')}
        </Heading>
        <StrongSides />
        <PricingWidget tariffs={tariffs} />
      </DefaultContainer>

      <DefaultContainer gap={{ base: 'md', md: '2xl' }}>
        <Heading textAlign='center'>{benefitsHeading}</Heading>
        <Flex
          flexWrap='wrap'
          gap='lg'
          justifyContent='center'
        >
          {benefits.map((benefit) => (
            <BenefitCard
              key={benefit.heading}
              {...benefit}
            />
          ))}
        </Flex>
      </DefaultContainer>

      <FAQ questions={questions} />
    </>
  );
};

export default PricingPage;
